//CSS
import "../../Components/Page/Page.css";
import "../../Pages/Investment/Investment.css";

//React
import React from "react";
import SecHeader from "../../Components/SecHeader/SecHeader";
import SubSection from "../../Components/Section/SubSection";

const SoftwareData: React.FC = () => {
    return (
        <div id="Goals" className="sectionContainer">
            <SecHeader title="E-SPEC™ Software" />

            <SubSection isSplit={false}>
                <div className="inv-items">
                    <div className="inv-item">
                        <h4 className="inv-item-title">Data From our 30 years of R&D​ ​</h4>
                        <p className="inv-item-body">
                            We developed methods to combine data for engine designs dating from the 1880s to this year and compared their strengths and weaknesses.
                            Our extensive engines databases grew to include information for millions of engines using old and new designs.​
                        </p>
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">E-SPEC (Engines – Size, Power, Efficiency Calculator)​ ​</h4>
                        <p className="inv-item-body">
                            Using optimization algorithms and “Mixed Methods Research,” we developed our proprietary software, E-SPEC, to predict and compare any engines’ physical and performance data.​​
                        </p>
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">E-SPEC is Unmatched and Will Become “Must-Use”​</h4>
                        <p className="inv-item-body">
                            E-SPEC users are allowed to access exlusive ELF-Tech engine data to compare engines and propose new ELF-Tech engine designs.​​
                            <br /><br />
                            We add exlusive ELF-Tech engine design data to allow our software users to compare engines and propose new ELF-Tech engine designs.​
                            <br /><br />
                            We add the data that only we have for ELF-Tech engine designs to permit our software users compare engines to each other and/or to proposed new engines and/or to ELF-Tech designs.​
                        </p>
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">E-SPEC Helps Protect IP & Monitor IP Infringement ​​</h4>
                        <p className="inv-item-body">
                            The software and its data gathering apps will process new engines and detect potential infringement on ELF-Tech designs. ​
                        </p>
                    </div>
                    <div className="inv-item">
                        <h4 className="inv-item-title">AI Data Gathering Helps Users​​</h4>
                        <p className="inv-item-body">
                            The extensive data (larger due to our AI apps) helps users get the most value as they use our software, and our curated data can teach other AI apps re: engine metrics comparing and ELF-Tech strengths.
                        </p>
                    </div>
                </div>
            </SubSection>
        </div>
    );
};

export default SoftwareData;
